const CircleActivity = <template>
  <section class="circles-tab-content">
    <div class="circles-activity-wrapper">
      <section class="circles-activity-content">
        {{outlet}}
      </section>
    </div>
  </section>
</template>;

export default CircleActivity;
